import React from 'react';
const defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
  if (customizePrefixCls) return customizePrefixCls;
  return suffixCls ? `ne-${suffixCls}` : 'ne';
};
const ConfigContext = React.createContext({
  getPrefixCls: defaultGetPrefixCls,
});
export default ConfigContext;



// WEBPACK FOOTER //
// ./src/skeleton/configContext.jsx